import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../core/language/language.service';
import { ComplaintList } from '../../core/models/administration/complaint-configuration/complaint-list';
import { SearchComplaints } from '../../core/models/complaint/search-complaints-list';
import { DropdownItem } from '../../core/models/dropdown-item';
import { SharedService } from '../../shared/shared.service';
import { ComplaintsService } from '../complaints.service';
import { ComplaintsService as ComplaintsReportService } from '../../../app/reports/complaints/complaints.service';
import { ComplaintDetailsById } from '../../core/models/reports/complaints/complaint-details-by-id';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-complaints-list',
  templateUrl: './complaints-list.component.html'
})
export class ComplaintsListComponent implements OnInit {

    public items: ComplaintList[];
    public categories: DropdownItem[] = [];
    public statuses: DropdownItem[] = [];
    public searchModel: SearchComplaints;
    private languageID: number;
    public pathname: string;

    public offset: number = 0;
    public limit: number = 10;
    public size: number = 0;
    public pageNum: number = 1;
    public pageSize: number = this.limit;    

    public isDesc: boolean = true;
    public column: string = "";

    public complaintReportModel: ComplaintDetailsById;

    constructor(private _complaintsService: ComplaintsService,
        private _complaintsReportService: ComplaintsReportService,
        private _sharedService: SharedService,
        private _languageService: LanguageService,        
        private router: Router) {
        this.items = [];
        this.searchModel = new SearchComplaints();
        this.complaintReportModel = new ComplaintDetailsById();
        this.languageID = this._languageService.selectedLanguageId;
        this.searchModel.languageId = this.languageID;
        this._sharedService.getAllCategoriesForDropdown(0, true, this.languageID).subscribe(result => {
            this.categories = result;
        });
        this._sharedService.getAllComplaintStatusesForDropdown(0, true, this.languageID).subscribe(result => {
            this.statuses = result;
        });        
    }

    ngOnInit() {
        this.pathname = location.pathname;
        this.initSearchModel();
        this.getAll();
    }

    getAll() {
        this.searchModel.pageNumber = this.pageNum;
        this.searchModel.pageSize = this.pageSize;
        this._complaintsService.searchComplaints(this.searchModel).subscribe(result => {
            this.items = result.results;
            this.createUniq();
           
            this.size = result.rowCount;           
        });
    }
    createUniq() {
        this.items = this.items.map(com => {
            return {
                ...com,
                complaintUniq: com.id + '-' + formatDate(com.dateCreated, 'ddMM-yyyy', 'en-US')
            }
        });
    }
    initSearchModel() {
        this.searchModel.languageId = this.languageID;
        this.searchModel.pageNumber = 1;
        this.searchModel.pageSize = 10;
        this.searchModel.title = null;
        this.searchModel.complaintUniq = null;
        this.searchModel.categoryId = 0;
        this.searchModel.statusId = 0;
        this.searchModel.column = "";
        this.searchModel.isDesc = this.isDesc;
    }

    search() {
        this.searchModel.pageNumber = this.pageNum;
        this.searchModel.pageSize = this.pageSize;
        this._complaintsService.searchComplaints(this.searchModel).subscribe(result => {
            this.items = result.results;
            this.createUniq();
            this.size = result.rowCount;
        });        
    }

    clearSearch() {
        this.offset = 0;
        this.pageNum = 1;
        this.pageSize = this.limit;
        this.initSearchModel();
        this.search();
    }

    onLimitChange(newLimit: number) {
        this.offset = 0;
        this.limit = newLimit;
        this.pageNum = 1;
        this.pageSize = newLimit;
        this.getAll();
    }

    onPageChange(offset: number) {
        this.offset = offset;
        this.pageNum = Math.floor(offset / this.limit) + 1;
        this.getAll();
    }

    sort(column: string) {
        // za font awesome
        this.column = column;
        this.isDesc = !this.isDesc;
        // za query
        this.searchModel.column = column;
        this.searchModel.isDesc = !this.searchModel.isDesc;
        this._complaintsService.searchComplaints(this.searchModel).subscribe(result => {
            this.items = result.results;
            this.size = result.rowCount;            
        });
    }

    redirectRoute(item: any) {
        if (item.statusId == 2) {
            this.router.navigate(['complaints/complaint-detail-inappropriate']);
        }
        else {
            this.router.navigate(['complaints/complaint-detail/' + item.id]);
        }
    }

    generateReport(id) {        
        var success = false;
        this.complaintReportModel.ID = id;
        this.complaintReportModel.languageId = this.languageID;
        this.complaintReportModel.contentType = 'application/pdf';

        return this._complaintsReportService.exportComplaintDetailsById(this.complaintReportModel).subscribe(result => {            
            var complaintDate = this.items.find(obj => obj.id === id).dateCreated;
            let filename = "Detalji o pritužbi " + id + "-" + formatDate(complaintDate,'ddMM-yyyy','en-US') + this._sharedService.getReportFileExtension("PDF");
            try {
                var blob = new Blob([result], { type: this._sharedService.getReportContentType("PDF") });                
                if (navigator.msSaveBlob)
                    navigator.msSaveBlob(blob, filename);
                else {
                    var saveBlob = navigator.msSaveBlob;
                    if (saveBlob === undefined) throw "Not supported";
                    saveBlob(blob, filename);
                }
                success = true;
            } catch (ex) { }

            if (!success) {
                var urlCreator = window.URL;
                if (urlCreator) {
                    var link = document.createElement('a');
                    if ('download' in link) {
                        try {
                            // Prepare a blob URL
                            var blob = new Blob([result], { type: this._sharedService.getContentType("PDF") });
                            var url = urlCreator.createObjectURL(blob);
                            link.setAttribute('href', url);
                            link.setAttribute("download", filename);

                            var event = document.createEvent('MouseEvent');
                            event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                            link.dispatchEvent(event);
                            success = true;
                        } catch (ex) { }
                    }
                }

                if (!success) {
                    try {
                        var blob = new Blob([result], { type: this._sharedService.getContentType("PDF") });
                        var url = urlCreator.createObjectURL(blob);
                        window.open(url, "_blank");
                        success = true;
                    } catch (ex) { }
                }
            }
        });
    }
    downloadPDF() {
        const pdfUrl = "../../../assets/documents/instructions/prituzbe.pdf";
        const pdfName = 'korisnicke_upute_prituzbe.pdf';

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = pdfName;
        link.click();
    }
    navigateToDetail(item: any): void {
        if (item.statusId == 2) {
            this.router.navigate(['../../complaints/complaint-detail-inappropriate']);
        } else {
            this.router.navigate(['../../complaints/complaint-detail/', item.id]);
        }
    }
}
